import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Route, Switch, Router } from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider } from "@material-ui/core";
import { history, StoreProvider, } from "ftl-core";
import FTLAuthPage from "../../templates/FTLAuthPage";
import FTLMainLayoutErrorBoundaryComponent from "../components/FTLMainLayoutErrorBoundaryComponent";
const FTLUIMainLayout = ({ AuthPageProps, project, AuthClient, StoreProviderProps, children, redirectOnAuthUrl, theme, }) => {
    var _a;
    const projectTitles = typeof project.title === "string"
        ? {
            authPage: `Войти в ${project.title}`,
            header: project.title,
        }
        : project.title;
    return (_jsxs(ThemeProvider, Object.assign({ theme: theme }, { children: [_jsx(CssBaseline, {}, void 0), _jsx(Router, Object.assign({ history: history }, { children: _jsx(StoreProvider, Object.assign({}, StoreProviderProps, { children: _jsxs(Switch, { children: [_jsx(Route, Object.assign({ exact: true, path: "/" }, { children: _jsx(FTLMainLayoutErrorBoundaryComponent, { children: _jsx(FTLAuthPage, Object.assign({ AuthClient: AuthClient, redirectOnAuthUrl: redirectOnAuthUrl, title: projectTitles.authPage, logo: (_a = project.logo) === null || _a === void 0 ? void 0 : _a.authPage }, AuthPageProps), void 0) }, void 0) }), void 0), children] }, void 0) }), void 0) }), void 0)] }), void 0));
};
export default FTLUIMainLayout;
//# sourceMappingURL=FTLUIMainLayout.js.map